import { Component, OnInit } from '@angular/core';
import { Category } from '../../models/category-model';
import { Product } from '../../models/product.model';
import { CategoryService } from '../../services/category.service';
import { ProductService } from '../../services/product.service';
import { CartService } from '../../services/cart.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-public-home',
    templateUrl: './public-home.component.html',
    styleUrl: './public-home.component.css'
})
export class PublicHomeComponent implements OnInit {
  categories: Category[] = [];
  products: Product[] = [];
  searchText: string = '';
  environment = environment;

  constructor(
    private categoryService: CategoryService,
    private productService: ProductService,
    private cartService: CartService
  ) {
  }

  ngOnInit() {
    this.loadCategories();
    this.loadDefaultProducts();
  }

  loadCategories() {
    this.categoryService.getTree().subscribe(data => {
      this.categories = data;
    });
  }

  loadDefaultProducts() {
    this.productService.getProducts().subscribe(data => {
      this.products = data;
      //this.cartService.refreshCartCount();
    });
  }

  loadProducts(categoryId: number) {
    this.productService.getProductsByCategory(categoryId).subscribe(data => {
      this.products = data;
    });
  }

  filteredProducts() {
    if (!this.searchText) return this.products;
    const text = this.searchText.toLowerCase();
    return this.products.filter(p => p.name.toLowerCase().includes(text));
  }
}
